import { Button, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ButtonBox from '@sophocles/views/auth/forms/ButtonBox';
import { MultiFactorCodeField } from '@sophocles/views/auth/forms/fields';

function MultiFactorChallengeForm({ error, challenge, isSubmitting, onSubmit, onCancel }) {
  const { t } = useTranslation();
  const [token, setToken] = useState('');

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(token);
  };

  const handleCancel = event => {
    event.preventDefault();
    setToken('');
    onCancel();
  };

  return (
    <Fragment>
      {challenge.parameters.medium && challenge.parameters.destination ? (
        <Typography variant="caption" color="gray" align="center" sx={{ mb: '32px', textAlign: 'center' }}>
          A code was sent via {challenge.parameters.medium.toLowerCase()} to: {challenge.parameters.destination}
        </Typography>
      ) : null}
      <form style={{ display: 'flex', flexDirection: 'column' }} onSubmit={handleSubmit}>
        <MultiFactorCodeField
          id="token"
          name="token"
          value={token}
          error={error}
          onChange={value => setToken(value)}
          disabled={isSubmitting}
          fullWidth
          sx={{ mb: 3 }}
        />
        <ButtonBox sx={{ px: 4, my: 2 }}>
          <Button
            id="submit-challenge"
            name="submit"
            variant="contained"
            disabled={token.length === 0 || isSubmitting}
            color="primary"
            type="submit"
            fullWidth
          >
            {t('actions.submit', 'Submit')}
          </Button>
          <Button
            id="cancel-challenge"
            name="cancel"
            variant="contained"
            color="secondary"
            type="cancel"
            fullWidth
            disabled={isSubmitting}
            onClick={handleCancel}
          >
            {t('actions.cancel', 'Cancel')}
          </Button>
        </ButtonBox>
      </form>
    </Fragment>
  );
}

export default MultiFactorChallengeForm;
